import React, { Component } from 'react'
import { Flex } from 'reflexbox'
import Checkbox from 'react-toolbox/lib/checkbox'

import FormTitle from 'components/fulcrum/formTitle/FormTitle'
import CSSModules from 'helpers/CSSModulesUtil'

import {
  TRUE,
  FALSE,
} from 'components/custom/FeatureButton/constants'
import styles from './styles.scss'

class FeatureCheckbox extends Component {
  onChangeSelection(featureObj) {
    return (val) => this.props.onChangeSelection(val ? TRUE : FALSE, featureObj)
  }

  render() {
    const {
      values,
    } = this.props
    return (
      <div>
        {
          values.map((item, index) => (
            <Flex key={ index } styleName='featureWrapper'>
              <Checkbox
                checked={item.label === TRUE}
                onChange={ this.onChangeSelection(item) }
                disabled={item.disabled}
              />
              <Flex styleName='title'>
                <span>{ item.value }</span>
              </Flex>
            </Flex>
          ))
        }
      </div>
    )
  }
}

export default CSSModules(styles, FeatureCheckbox)
